var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMarkFiled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_328",
    "data-name": "Rectangle 328",
    width: 20,
    height: 20,
    transform: "translate(679 1356)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_13",
    "data-name": "Mask Group 13",
    transform: "translate(-679 -1356)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "help_FILL1_wght400_GRAD0_opsz48",
    d: "M87.787,188.2a.724.724,0,1,0-.52-.212A.707.707,0,0,0,87.787,188.2Zm-.675-2.814h1.137a3.154,3.154,0,0,1,.125-.915,2.269,2.269,0,0,1,.781-.954,3.372,3.372,0,0,0,.848-.983,2.263,2.263,0,0,0,.251-1.06,2.128,2.128,0,0,0-.665-1.638,2.49,2.49,0,0,0-1.764-.617,2.979,2.979,0,0,0-1.667.472,2.7,2.7,0,0,0-1.05,1.3l1.021.385a1.8,1.8,0,0,1,.636-.838,1.7,1.7,0,0,1,1-.3,1.545,1.545,0,0,1,1.06.357,1.165,1.165,0,0,1,.4.915,1.417,1.417,0,0,1-.251.8,3.839,3.839,0,0,1-.732.781,3.92,3.92,0,0,0-.858.993A2.623,2.623,0,0,0,87.112,185.386Zm.6,6.033a7.46,7.46,0,0,1-2.987-.607,7.767,7.767,0,0,1-4.115-4.115,7.7,7.7,0,0,1,0-5.994,7.7,7.7,0,0,1,1.658-2.448,7.9,7.9,0,0,1,2.457-1.648,7.7,7.7,0,0,1,5.994,0,7.7,7.7,0,0,1,4.1,4.1,7.7,7.7,0,0,1,0,5.994,7.9,7.9,0,0,1-1.648,2.457,7.7,7.7,0,0,1-2.448,1.658A7.507,7.507,0,0,1,87.709,191.419Z",
    transform: "translate(601.291 1182.291)",
    fill: "#0073b2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkFiled);
export default __webpack_public_path__ + "static/media/question_mark_filed.aafc158f4f834a8d288cefc554a1bc51.svg";
export { ForwardRef as ReactComponent };